import styledComponent from './styledComponent'
import {getVal, getValFromTheme} from './styledComponent'

// -> allowed roles to access this route

export {styledComponent, getValFromTheme, getVal}



// WEBPACK FOOTER //
// src/higherOrderComponent/index.js